/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_AgentInputs */

const cs_col_agent = /** @type {(inputs: Col_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléř`)
};

const en_col_agent = /** @type {(inputs: Col_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Col_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_agent = /** @type {((inputs?: Col_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_agent(inputs)
	return cs_col_agent(inputs)
});